import { mapGetters } from "vuex";
import { stringHelper } from "@/components/mixins/stringHelper";

  export default {
    name: "MleCountryOfOriginSummary",
    mixins: [stringHelper],
    props: {
      invoiceDetails: {
        type: Object,
        default: null
      }
    },
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"]),
      lineItems(){
        return this.invoiceDetails.LineItems;
      },
      countries(){
        return [...new Set(this.invoiceDetails.LineItems.map(x => x.CountryOfOrigin))];
      },
      groupItemsByCountry(){
        var groupings = [];
        this.countries.forEach(x => {
          var items = this.invoiceDetails.LineItems.filter(item => item.CountryOfOrigin === x);
          groupings[x] = items;
        })
        return groupings;
      }
    },
    methods:{
      getGrossWeight(country){
        var sum = 0;
        this.groupItemsByCountry[country].map(x => {
          sum += x.GrossWeight;
        })
        //Gross weight is often not set - return 0 rather than NaN
        return sum ? this.formatToCommaDecimal(sum): 0;
      },
      getNetWeight(country){
        var sum = 0;
        this.groupItemsByCountry[country].map(x => {
          sum += x.NetWeight;
        })
        return this.formatToCommaDecimal(sum);
      },
      getValue(country) 
      { 
        var sum = 0;
        this.groupItemsByCountry[country].map(x => {
          sum += x.UnitPrice;
        })
        return sum;
      },
      getQuantity(country){
        var sum = 0;
        this.groupItemsByCountry[country].map(x => {
          sum += x.QuantityShipped;
        })
        return sum;
      }
    },
  };